import React from 'react'
import { useTranslation } from 'react-i18next'
import { tagService } from '../../services/tag.service'
import { Tag } from '../../types'
import { flattenTags } from '../../utils/flattenTags'
import { ManagementList } from '../common/ManagementList'
import { TagEditDialog } from './TagEditDialog'

export const TagList: React.FC = () => {
  const { t } = useTranslation()

  const filterData = (data: Tag[], nameFilter?: string) => {
    if (nameFilter?.length) {
      return [...data]
    }
    const flattened = flattenTags(data)
    return flattened.filter((tag) => !tag.parent)
  }

  const getDeleteMessage = (object: Tag) => {
    return t('confirm_delete_tag', { name: object.name })
  }

  const extraColumns = [
    {
      key: 'color',
      name: t('color'),
      rendersHtml: true,
      valueFn: (tag: Tag) => {
        return `<span class="badge" style="color: ${tag.text_color}; background-color: ${tag.color}">${tag.color}</span>`
      },
    },
  ]

  return (
    <ManagementList
      service={tagService}
      editDialogComponent={TagEditDialog}
      typeName={t('tag')}
      typeNamePlural={t('tags')}
      permissionType="tag"
      extraColumns={extraColumns}
      filterData={filterData}
      getDeleteMessage={getDeleteMessage}
      info={t('tags_info')}
      infoLink="tags"
    />
  )
}
